/* eslint-disable no-param-reassign */
import packageInfo from '../../../package.json';
import addRecencyFunctionScore from './utils/add-recency-function-score';
import {
  PLUGIN_NAME,
  BOOST_SCORES,
  MUST_FILTERS,
  FILTER_PROPERTIES,
  SMALL_BOOST_PROPERTIES,
  BIG_BOOST_PROPERTIES
} from './constants';

const { version } = packageInfo;

async function load(app) {
  app.log.debug('loaded list-query-variables-plugin');

  // Note: any change to either of these events must be made for both events so they match
  app.events.on('plugin:page-builder:list:query-variables:sync', ({ data = {}, props = {} }) => {
    const { name } = props;
    const { sort, rawQueryStringified } = data;
    if (
      name !== 'list-articles' ||
      rawQueryStringified.includes('function_score') ||
      !sort.startsWith('_score')
    )
      return;

    const parsedRawQuery = JSON.parse(rawQueryStringified);

    // eslint-disable-next-line no-undef
    const queryShoulds = parsedRawQuery?.bool?.must[0]?.bool?.must[0]?.bool?.should || [];

    if (queryShoulds.length) {
      queryShoulds.forEach(({ match }) => {
        FILTER_PROPERTIES.forEach(property => {
          if (match[property]) match[property].operator = 'AND';
        });

        if (match.name) {
          queryShoulds.push({
            match_phrase: {
              name: {
                query: match.name.query,
                boost: BOOST_SCORES.BIG
              }
            }
          });
        }

        SMALL_BOOST_PROPERTIES.forEach(field => {
          if (match[field]) {
            queryShoulds.push({
              match_phrase: {
                [field]: {
                  query: match[field].query,
                  boost: BOOST_SCORES.SMALL
                }
              }
            });
          }
        });
      });
    }

    const updatedData = addRecencyFunctionScore(parsedRawQuery);

    data.rawQueryStringified = JSON.stringify(updatedData);
  });

  app.events.on('plugin:page-builder:searchcontent:query-variables:sync', ({ data, props }) => {
    const { variables: { rawQuery } = {} } = data;
    const { entities = [] } = props;

    if (
      !rawQuery ||
      !rawQuery.query ||
      !rawQuery.query.bool ||
      !rawQuery.query.bool.must ||
      !rawQuery.query.bool.must[0] ||
      !rawQuery.query.bool.must[0].query_string
    ) {
      return data;
    }

    const keywords = rawQuery.query.bool.must[0].query_string.query;
    const standardQueries = FILTER_PROPERTIES.map(property => ({
      match: {
        [property]: {
          query: keywords,
          fuzziness: 'AUTO',
          prefix_length: 3,
          operator: 'AND'
        }
      }
    }));
    const bigBoostQueries = BIG_BOOST_PROPERTIES.map(property => ({
      match_phrase: {
        [property]: {
          query: keywords,
          boost: BOOST_SCORES.BIG
        }
      }
    }));
    const smallBoostQueries = SMALL_BOOST_PROPERTIES.map(property => ({
      match_phrase: {
        [property]: {
          query: keywords,
          boost: BOOST_SCORES.SMALL
        }
      }
    }));
    const query = {
      bool: {
        must: [
          {
            bool: {
              must: [
                {
                  bool: {
                    should: [...standardQueries, ...bigBoostQueries, ...smallBoostQueries]
                  }
                }
              ]
            }
          }
        ],
        should: [
          {
            match: {
              pageBuilderIndexed: {
                query: keywords,
                fuzziness: 'AUTO',
                prefix_length: 3
              }
            }
          }
        ],
        filter: {
          bool: {
            should: entities.map(entity => ({
              match: {
                docType: entity
              }
            })),
            minimum_should_match: 1,
            must: MUST_FILTERS
          }
        }
      }
    };

    const newQuery = addRecencyFunctionScore(query);
    data.variables.rawQuery = newQuery;
    data.variables.sort = '_score,sponsored:desc,featured:desc,date:desc';

    return data;
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
